/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(".navbar-toggle").click(function(){
          $(".menu-overlay").fadeToggle(200);
          // $(this).toggleClass('btn-open').toggleClass('btn-close');
        });

        $(".close").click(function(){
          $(".menu-overlay").fadeToggle(200);
          // $(this).toggleClass('btn-open').toggleClass('btn-close');
        });

        // close menu overlay when link is clicked
        $(".menu-overlay ul li a").click(function(){
          $(".menu-overlay").fadeToggle(200);
        });


        //PAGE-LOADER
        setTimeout(function(){
          $('.page-loader').fadeOut();
        }, 2000);

        //wpcf7
        $('.wpcf7-form').prepend($('div.wpcf7-response-output'));

        //back to top
        $('#back-to-top').click(function(){
          console.log('back-to-top');
          $("html, body").animate({ scrollTop: 0 }, "slow");
          return false;
        });
        $(document).scroll(function(){
          if($('html').scrollTop() > 600){
            $('#back-to-top').show();
          } else {
            $('#back-to-top').hide();
          }
        });



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // Parallax
        var scene = document.getElementById('scene');
        var parallaxInstance = new Parallax(scene);

        // Stellar
        $.stellar();

        // wow
        new WOW().init();
        // reset animation on top
        $(window).scroll(function(){
          if( $(window).scrollTop() <= 50) {
            $('.wow').removeClass('animated');
            $('.wow').removeAttr('style');
            new WOW().init();
          }
        });





        //hero
        var heroFitWindow = function(){
          var $hero = $('.hero');
          var windowH = $(window).innerHeight() - ($hero.css('padding-top') + $hero.css('padding-bottom'));
          $hero.height(windowH);
        }
        $(window).resize(heroFitWindow);
        heroFitWindow();

        //step
        $(window).scroll(function(){
          if( $(window).scrollTop() > $('.comment-ca-marche').offset().top - 200) {

            console.log('step is launched');

            var $owl_screen = $('.owl-carousel-screen');
            $owl_screen.owlCarousel({
                animateOut: 'fadeOut',
                // animateIn: 'fadeIn',
                loop:true,
                margin:0,
                nav:false,
                dots:false,
                mouseDrag:false,
                pullDrag:false,
                freeDrag:false,
                items:1,
                autoplayHoverPause: true
            });

            var $owl_step = $('.owl-carousel-step');
            $owl_step.on('initialize.owl.carousel', function(event) {

                  setTimeout(function(){
                    console.log('screen-first');
                    console.log($('img.screen-first'));
                    $('img.screen-first').animate({ marginLeft : 0 }, "slow");
                  },3500);

            });
            $owl_step.owlCarousel({
                loop:true,
                margin:10,
                nav:true,
                autoplay: true,
                autoplayTimeout: 7000,
                items:1,
                autoplayHoverPause: true
            });
            $owl_step.on('changed.owl.carousel', function(event) {
                var current_index = event.page.index;
                $owl_screen.trigger('to.owl.carousel', [current_index]);
                console.log(event);
                if(event.page.index == 0) {

                  setTimeout(function(){
                    console.log('screen-first');
                    console.log($('img.screen-first'));
                    $('img.screen-first').animate({ marginLeft : 0 }, "slow");
                  },2500);
                } else {
                  setTimeout(function(){
                    $('img.screen-first').css({ 'margin-left' : '-60%' });
                  }, 800);
                }
            });
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
